import React, { useState, useEffect } from "react";
import { api, authHeaders } from "@/lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import { Star, Loader2 } from "lucide-react";
import { toast } from "sonner";

// Immediate review compose dialog. Posts to /stores/{vendorId}/reviews.
export default function LeaveReviewDialog({ open, onOpenChange, vendorId, storeName, initialRating = 5, claimId, onDone }) {
  const [rating, setRating] = useState(initialRating);
  const [comment, setComment] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => { if (open) { setRating(initialRating || 5); setComment(""); } }, [open, initialRating]);

  const submit = async () => {
    if (rating < 1) return toast.error("Seleziona una valutazione");
    setSaving(true);
    try {
      const body = { rating, comment: comment.trim() };
      if (claimId) body.claim_id = claimId;
      await api.post(`/stores/${vendorId}/reviews`, body, { headers: authHeaders("client") });
      toast.success("Grazie per la recensione!");
      onOpenChange(false);
      onDone && onDone();
    } catch (e) { toast.error(e?.response?.data?.detail || "Errore nell'invio"); }
    finally { setSaving(false); }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md rounded-3xl" data-testid="leave-review-dialog">
        <DialogHeader><DialogTitle className="text-xl font-extrabold">Recensisci {storeName || "il negozio"}</DialogTitle></DialogHeader>
        <div className="space-y-4">
          <div className="flex items-center justify-center gap-2">
            {[1, 2, 3, 4, 5].map((n) => (
              <button key={n} type="button" data-testid={`review-star-${n}`} onClick={() => setRating(n)}>
                <Star className={`h-9 w-9 ${n <= rating ? "fill-amber-400 text-amber-400" : "text-slate-300"}`} />
              </button>
            ))}
          </div>
          <Textarea data-testid="review-comment" value={comment} onChange={(e) => setComment(e.target.value)}
            placeholder="Racconta com'è andata (facoltativo)" className="rounded-xl min-h-[90px]" />
          <div className="flex gap-2">
            <Button variant="outline" onClick={() => onOpenChange(false)} className="flex-1 h-11 rounded-xl font-bold">Annulla</Button>
            <Button onClick={submit} disabled={saving} data-testid="review-submit" className="flex-1 h-11 rounded-xl font-bold">
              {saving ? <Loader2 className="h-4 w-4 animate-spin" /> : "Invia recensione"}
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
